/*
 * This file is generated by icons/template.js
 */
const SvgHome = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 22 18" {...props}>
		<path
			fill="#707070"
			d="M2.875 16.333V8.192L1.542 9.217q-.29.216-.62.166a.83.83 0 0 1-.547-.333.79.79 0 0 1-.166-.617.84.84 0 0 1 .325-.55L2.875 6.1V4q0-.354.24-.594a.8.8 0 0 1 .597-.24q.355 0 .593.24A.8.8 0 0 1 4.542 4v.825L9.867.775a1.64 1.64 0 0 1 1.01-.342q.557 0 1.007.342l9.35 7.125q.273.21.316.547a.84.84 0 0 1-.175.626.8.8 0 0 1-.541.31.78.78 0 0 1-.6-.175l-1.359-1.016v8.141q0 .688-.49 1.178-.489.489-1.176.489H4.542q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177m1.667 0h5.5v-3.166q0-.354.24-.594.241-.24.596-.24a.8.8 0 0 1 .593.24.8.8 0 0 1 .238.594v3.166h5.5V6.917l-6.334-4.825-6.333 4.825z"
		/>
	</svg>
);
SvgHome.displayName = 'iconHome';
export default SvgHome;
